<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix modal-heading">
      <span>Reorder Campaigns</span>
      <el-button type="text" @click="$modal.hide('campaign-sort-form')">
        <font-awesome-icon icon="window-close" fixed-width></font-awesome-icon>
      </el-button>
    </div>

    <el-alert
      title="Drag'n'drop Campaigns into your desired order and press Save to continue."
      type="info"
      style="margin-bottom: 0.5rem"
    ></el-alert>

    <div class="drag-container">
      <vue-draggable v-model="campaigns">
        <el-row
          v-for="(campaign, key) in campaigns"
          :key="campaign.slug"
          type="flex"
          class="campaign-row"
        >
          <el-col style="flex: 0; min-width: 50px; font-weight: bold">
            {{ key + 1 }}
          </el-col>
          <el-col style="flex: 1">
            {{ campaign.name }}
          </el-col>
        </el-row>
      </vue-draggable>
    </div>

    <el-button
      @click="submit"
      type="primary"
      plain
      medium
      :style="{ width: '100%' }"
      v-loading="loading"
    >
      Save
    </el-button>
  </el-card>
</template>

<style lang="scss">
.drag-container {
  box-shadow: 0 0 0 1px #c8cdd0;
  padding: 0.5rem;
  margin-bottom: 0.5rem;

  .campaign-row {
    padding: 0.5rem;
    font-size: 1rem;
    background-color: #fefefe;
    cursor: move;
  }

  .campaign-row:nth-child(2n) {
    background-color: #fafafa;
  }
}

.sortable-ghost {
  background-color: rgba(64, 158, 255, 0.3) !important;
}
</style>

<script>
import VueDraggable from "vuedraggable"
import { mapActions } from "vuex"

export default {
  name: "CampaignSortForm",

  components: {
    VueDraggable,
  },

  props: {
    data: {
      required: true,
    },
  },
  data() {
    return {
      campaigns: [],
      loading: false,
    }
  },
  computed: {
    action() {
      return (
        "campaigns/" +
        this.$route.params.company +
        "/" +
        this.$route.params.month +
        "/order/"
      )
    },
  },

  methods: {
    ...mapActions({
      updateCampaigns: "campaigns/set",
    }),
    submit() {
      let order = this.$_.map(this.campaigns, "id")
      this.loading = true

      this.axios
        .post(this.action, { order: order })
        .then((response) => {
          this.updateCampaigns(response.data.data)
          this.$message.success(response.data.message)
          this.loading = false
          this.$modal.hide("campaign-sort-form")
        })
        .catch((resp) => {
          this.loading = false
          this.$root.globalRequestError(resp)
        })
    },
  },

  created() {
    this.campaigns = this.$_.cloneDeep(this.data)
  },
}
</script>
